// extracted by mini-css-extract-plugin
module.exports = {"Tabs":"Tabs_Tabs__mOL6w","tab":"Tabs_tab__hgjOl","active":"Tabs_active__83D0_"};